import { render } from "./AppBanner.vue?vue&type=template&id=530606a9"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\skyle\\source\\repos\\skylab\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__